var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "techcar" } },
    [
      _c(
        "v-container",
        [
          _c("h1", { staticClass: "mb-4 mt-20px" }, [_vm._v("Techcar")]),
          _c(
            "v-card",
            {},
            [
              _c(
                "v-card-text",
                { staticClass: "pa-8" },
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", [
                        _c("p", { staticClass: "f18 mb-0 white100" }, [
                          _vm._v("Obhliadka")
                        ])
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control required",
                            attrs: {
                              value: _vm.miestoObhliadky,
                              label: "Miesto obhliadky",
                              rules: [_vm.rules.required],
                              outlined: "",
                              required: ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control required",
                            attrs: {
                              value: _vm.kontaktnaOsoba,
                              label: "Kontaktná osoba k obhliadke",
                              rules: [_vm.rules.required],
                              outlined: "",
                              required: ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control required",
                            attrs: {
                              value: _vm.telCislo,
                              label: "Tel. kontakt",
                              rules: [_vm.rules.required],
                              outlined: "",
                              required: ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c("v-col", [
                        _c("p", { staticClass: "f18 mb-0 white100" }, [
                          _vm._v("Predmet financovania")
                        ])
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control",
                            attrs: {
                              value: _vm.farba,
                              label: "Farba",
                              outlined: "",
                              "hide-details": ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control",
                            attrs: {
                              value: _vm.rokVyroby,
                              label: "Rok výroby",
                              outlined: "",
                              "hide-details": ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control",
                            attrs: {
                              value: _vm.oznacenie,
                              label: "Označenie TP",
                              outlined: "",
                              "hide-details": ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-0" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control",
                            attrs: {
                              value: _vm.vin,
                              label: "VIN",
                              outlined: "",
                              "hide-details": ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control",
                            attrs: {
                              value: _vm.ecv,
                              label: "ŠPZ/EČV",
                              outlined: "",
                              "hide-details": ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-expansion-panels",
                    {
                      staticClass: "wizard-expansion-panels px-1 mb-5",
                      attrs: { flat: "" },
                      model: {
                        value: _vm.expandPanel,
                        callback: function($$v) {
                          _vm.expandPanel = $$v
                        },
                        expression: "expandPanel"
                      }
                    },
                    [
                      _c(
                        "v-expansion-panel",
                        [
                          _c(
                            "v-expansion-panel-header",
                            { staticClass: "pa-0 mt-6" },
                            [_vm._v(" Dodatočné informácie ")]
                          ),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c(
                                "v-row",
                                { staticClass: "mt-2" },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "dynamic-input-control",
                                        attrs: {
                                          value: _vm.obchodnik,
                                          label: "Obchodník TL",
                                          outlined: "",
                                          "hide-details": "",
                                          disabled: ""
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "dynamic-input-control",
                                        attrs: {
                                          value: _vm.emailObchodnik,
                                          label: "E-mail obchodníka",
                                          outlined: "",
                                          "hide-details": "",
                                          disabled: ""
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "dynamic-input-control",
                                        attrs: {
                                          value: _vm.predmetFinanc,
                                          label: "Predmet financovania",
                                          outlined: "",
                                          "hide-details": "",
                                          disabled: ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                { staticClass: "mt-0" },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "dynamic-input-control",
                                        attrs: {
                                          value: _vm.obstarCenaBezDph,
                                          label: "Obstarávacia cena bez DPH",
                                          outlined: "",
                                          "hide-details": "",
                                          disabled: ""
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "dynamic-input-control",
                                        attrs: {
                                          value: _vm.ostarCenaSDph,
                                          label: "Obstarávacia cena s DPH",
                                          outlined: "",
                                          "hide-details": "",
                                          disabled: ""
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "dynamic-input-control",
                                        attrs: {
                                          value: _vm.pocetKm,
                                          label: "Počet kilometrov",
                                          outlined: "",
                                          "hide-details": "",
                                          disabled: ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                { staticClass: "mt-0" },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "dynamic-input-control",
                                        attrs: {
                                          value: _vm.ziadatel,
                                          label: "Žiadateľ o financovanie",
                                          outlined: "",
                                          "hide-details": "",
                                          disabled: ""
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "dynamic-input-control",
                                        attrs: {
                                          value: _vm.dodavatel,
                                          label: "Dodávateľ vozidla",
                                          outlined: "",
                                          "hide-details": "",
                                          disabled: ""
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "dynamic-input-control",
                                        attrs: {
                                          value: _vm.sposobFinanc,
                                          label:
                                            "Spôsob financovania (FL/SU/SP/OL)",
                                          outlined: "",
                                          "hide-details": "",
                                          disabled: ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                { staticClass: "mt-0" },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "dynamic-input-control",
                                        attrs: {
                                          value: _vm.akontacia,
                                          label: "Akontácia/vlastné zroje",
                                          outlined: "",
                                          "hide-details": "",
                                          disabled: ""
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "dynamic-input-control",
                                        attrs: {
                                          value: _vm.tenor,
                                          label: "Doba splácania v mesiacoch",
                                          outlined: "",
                                          "hide-details": "",
                                          disabled: ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            { staticClass: "mt-6" },
            [
              _c(
                "v-card-text",
                { staticClass: "pa-8" },
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", [
                        _c("p", { staticClass: "f18 mb-0 white100" }, [
                          _vm._v("Prílohy")
                        ]),
                        _c("span", [
                          _vm._v("Nahrajte tieto prílohy - "),
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "700" } },
                            [_vm._v("Veľký technický preukaz")]
                          ),
                          _vm._v(" (povinné) a "),
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "700" } },
                            [_vm._v("Kontrola originality")]
                          ),
                          _vm._v(" (nepovinné)")
                        ])
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "ml-auto", attrs: { cols: "auto" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-secondary px-28px py-20px",
                              attrs: {
                                density: "default",
                                variant: "elevated"
                              },
                              on: {
                                click: function($event) {
                                  _vm.uploadDokument = true
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v(" mdi-upload-outline ")
                              ]),
                              _vm._v(" Nahrať dokument ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-data-table", {
                            ref: "dokumentyRef",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.items,
                              "hide-default-footer": "",
                              page: _vm.page,
                              "items-per-page": 9,
                              "item-key": "id_dokumentu",
                              loading: _vm.loading,
                              loadingText: "Načítavam dáta ..."
                            },
                            on: {
                              "update:page": function($event) {
                                _vm.page = $event
                              },
                              "page-count": function($event) {
                                _vm.pageCount = $event
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item.poznamka",
                                  fn: function(ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "text-overflow-dots" },
                                        [_vm._v(_vm._s(item.poznamka))]
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "item.datum_modifikacie",
                                  fn: function(ref) {
                                    var item = ref.item
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.datum_modifikacie
                                              ? item.datum_modifikacie.formatDate()
                                              : ""
                                          ) +
                                          " "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "item.akcie",
                                  fn: function(ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            "content-class": "",
                                            transition: "slide-x-transition",
                                            "offset-x": "",
                                            left: "",
                                            "close-delay": "100"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              dark: "",
                                                              icon: ""
                                                            }
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        _vm.loadMenuDokumentu(
                                                          item,
                                                          on
                                                        )
                                                      ),
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v(
                                                            "mdi-dots-vertical"
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _c(
                                            "v-list",
                                            { attrs: { elevation: "1" } },
                                            _vm._l(item.menu, function(m, i) {
                                              return _c(
                                                "v-list-item",
                                                {
                                                  key: i,
                                                  class: m.color,
                                                  attrs: {
                                                    link: "",
                                                    dense: "",
                                                    disabled: !m.isEnabled
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.actionClick(
                                                        m,
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-icon",
                                                    { staticClass: "mr-4" },
                                                    [
                                                      _c("v-icon", {
                                                        staticClass:
                                                          "material-icons-outlined icon-block",
                                                        attrs: { size: "24" },
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            m.icon
                                                          )
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-list-item-title", [
                                                    _vm._v(_vm._s(m.nazov))
                                                  ])
                                                ],
                                                1
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }